import calc from 'calculatorjs'

function parcelFeeOf (sr, ctx) {
  if (ctx.allItemInclFreight === 'Y') return 0
  if (!sr) return 0
  if (ctx.isBizFee && sr.parcelsFeeBiz) return sr.parcelsFeeBiz
  if (sr.transport !== 'sea' && ctx.jyoShpMethod === '1') {
    if (ctx.useFeeType === 'frt') return sr.parcelsFeeFrt || 0
    if (ctx.useFeeType === 'tax') return sr.parcelsFeeInclTax || 0
  }
  return sr.parcelsFee || 0
}

export function computeFeeInfo (ctx) {
  const sr = ctx.shippingRatesInfo
  let parcelsFee = 0
  let parcelsFeeFormulas = null
  let discountSr = null
  let discountParcelsFeeFormulas = null
  let discountParcelsFee = 0

  if (sr.transport) {
    if (sr.transport === 'sea' && ctx.seaInfo.isSeaAddr && !ctx.seaInfo.isFurniture && !ctx.seaInfo.isMold6x) {
      parcelsFee = 0
    } else {
      parcelsFeeFormulas = ctx.parcelsFeeFormulas
      parcelsFee = parcelsFeeFormulas?.parcelsFee || parcelFeeOf(sr, ctx)
      if (ctx.useFinalDiscountRate) discountSr = ctx.bestDiscountSr
      if (discountSr) {
        discountParcelsFeeFormulas = ctx.edition === 's'
          ? discountSr.parcelsFeeFormulasBiz
          : discountSr.parcelsFeeFormulas
        discountParcelsFee = parcelFeeOf(discountSr, ctx)
      }
    }
  }

  // brand-fence:start id=shared-city-discount-rate brand=data-driven predicate=data-driven
  let cityParcelFeeFormulas = null
  let cityParcelsFee = 0
  if (sr.srExtras?.citiesPriceOff && ctx.addrInfo && !discountParcelsFeeFormulas) {
    const city = ctx.addrInfo.city
    const priceOffCity = Object.keys(sr.srExtras.citiesPriceOff).find(key => city === key)
    if (priceOffCity) {
      const priceOff = sr.srExtras.citiesPriceOff[priceOffCity]
      parcelsFee = calc.sub(parcelsFee, priceOff)

      cityParcelFeeFormulas = JSON.parse(JSON.stringify(ctx.parcelsFeeFormulas))
      cityParcelFeeFormulas.fwFees[2] = calc.sub(cityParcelFeeFormulas.fwFees[2], priceOff)
      cityParcelFeeFormulas.fwFees[4] = calc.mul(cityParcelFeeFormulas.fwFees[0], cityParcelFeeFormulas.fwFees[2])
      cityParcelsFee = cityParcelFeeFormulas.fwFees[4]

      discountParcelsFeeFormulas = cityParcelFeeFormulas
      discountParcelsFee = cityParcelsFee
      discountSr = {
        ...sr,
        srLabel: 'CITY',
      }
    }
  }
  // brand-fence:end id=shared-city-discount-rate

  return {
    sr,
    parcelsFeeFormulas,
    parcelsFee,
    discountSr,
    discountParcelsFeeFormulas,
    discountParcelsFee,
    finalSr: discountSr || sr,
    finalParcelsFee: discountParcelsFeeFormulas ? discountParcelsFee : parcelsFee,
    finalParcelsFeeFormulas: discountParcelsFeeFormulas || parcelsFeeFormulas,
  }
}

export default computeFeeInfo
